import { FC } from 'react';
import { useDrawer } from 'src/hooks/useDrawer';
import { Outlet } from 'react-router';
import { HeaderInner } from '../components/Header/HeaderInner';
import './styles.css';
import { useBackgroundScrollLock } from 'react-easyrocket';
import { twMerge } from 'tailwind-merge';
import { WrapperWithSidebar } from './components/WrapperWithSidebar';
import { AccountHeader } from './components/AccountHeader';
import { Header } from '../components/Header/Header';
import { ProfileNavigation } from './components/ProfileNavigation';

export const AccountLayout: FC = () => {
  const { isLeftDrawerOpen } = useDrawer();

  useBackgroundScrollLock(isLeftDrawerOpen, [isLeftDrawerOpen]);

  return (
    <div
      className={twMerge(
        'account-layout-wrapper min-h-screen',
        location.pathname.includes('account/vip') ? 'account-layout-wrapper-vip-location' : ''
      )}>
      <Header
        accountHeader
        additionalClassName={twMerge('z-[600]', isLeftDrawerOpen ? 'blured' : '')}
        accountHeaderChildren={<AccountHeader />}>
        <HeaderInner />
      </Header>
      <WrapperWithSidebar>
        <div
          className="1024:w-[90%] w-full max-w-[1440px] mx-auto flex justify-center flex-row 1024:max-h-[650px] 1920:h-[800px] 1024:mt-[calc((100vh_-_600px_-85px)/2)] 1920:mt-[calc((100vh_-_800px_-85px)/2)] 1024:rounded-xl"
          style={{
            filter: `${isLeftDrawerOpen ? 'blur(5px) brightness(50%)' : 'none'}`
          }}>
          <ProfileNavigation />
          <div className="768:overflow-y-auto w-full py-4 max-w-[1000px] 1024:bg-ga_window account">
            <Outlet />
          </div>
        </div>
      </WrapperWithSidebar>
    </div>
  );
};
